<template>
  <div>
    <a-row>
      <a-col :span="24">
        <a-form layout="inline" class="mb20">
          <a-form-item label="实验名称">
            <a-input
              v-model:value="searchForm.name"
              allowClear
              placeholder="请输入"
            ></a-input>
          </a-form-item>
          <a-form-item label="实验ID">
            <a-input
              v-model:value="searchForm.id"
              allowClear
              placeholder="请输入"
            ></a-input>
          </a-form-item>

          <a-form-item label="创建人">
            <div class="oh fl  mr20">
              <div class="fl">
                <a-select
                  ref="select"
                  allowClear
                  v-model:value="searchForm.userName"
                  placeholder="请输入创建人"
                  @change="getTableList"
                  show-search
                  optionFilterProp="label"
                  :options="userList"
                >
                </a-select>
              </div>
            </div>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="20">
        <a-form layout="inline">
          <a-form-item label="实验层">
            <a-select
              style="width: 130px"
              show-search
              v-model:value="searchForm.layerId"
              :options="layerList"
              :filterOption="filterOption"
              allowClear
            />
          </a-form-item>
          <a-form-item label="实验类型">
            <a-select
              style="width: 130px"
              v-model:value="searchForm.type"
              :options="AB_TEST_TYPES"
              allowClear
            />
          </a-form-item>
          <a-form-item label="实验状态">
            <a-select
              style="width: 130px"
              v-model:value="searchForm.status"
              :options="statusOptionList"
              placeholder="ALL"
              allowClear
            />
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="4">
        <a-space>
          <a-button type="primary" @click="searchFormData">查询</a-button>
          <a-button type="default" @click="resetFormData">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { defineComponent, inject, reactive, toRefs, ref } from 'vue'
import { user_list } from '@/server/modules/filter'
import { AB_TEST_TYPES } from '../ruleData'

export default defineComponent({
  name: 'AddressRule',
  setup() {
    const state = reactive({
      dataSource: []
    })
    let userList = ref([])

    async function getUserList() {
      const { success, data } = await user_list()
      if (success) {
        userList.value = data.map(item => ({
          label: item.name,
          value: item.name
        }))
      }
    }
    getUserList()
    return {
      AB_TEST_TYPES,
      userList,
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
})
</script>
